export const iconFontAwesomeCampingMountainSun = (
	<i className="fa-solid fa-mountain-sun"></i>
);
